module.exports = __webpack_public_path__ + "static/media/webform.738dc700.svg";